import React from "react";
import { Check } from "lucide-react";

const steps = (p) => {
  const leads = p.leads || [];
  return [
    { t: "Brief & κοινό", d: "Χώρα, προϊόν, κανόνες, budget", done: !!(p.product && (p.countries || []).length) },
    { t: "Queries", d: "Πρόταση από AI ή χειροκίνητα", done: (p.queries || []).length > 0 },
    { t: "Αναζήτηση", d: "Internet, Explee ή αποθηκευμένα", done: leads.length > 0 },
    { t: "Εμπλουτισμός & έλεγχος site", d: "Τηλέφωνα, AI, απόδειξη", done: leads.length > 0 && leads.every((l) => l.status === "rejected" || l.verify) },
    { t: "Έγκριση & Excel", d: "Ελέγχετε και κατεβάζετε", done: leads.some((l) => l.status === "approved") },
  ];
};

export const WorkflowGuide = ({ project }) => {
  const list = steps(project);
  const current = list.findIndex((s) => !s.done);
  return (
    <ol className="grid grid-cols-1 sm:grid-cols-5 gap-2" data-testid="agency-workflow-guide">
      {list.map((s, i) => (
        <li key={s.t} data-testid={`workflow-step-${i + 1}`}
          className={`rounded-md border p-2.5 transition-colors duration-200 ${s.done ? "border-emerald-200 bg-emerald-50/60" : i === current ? "border-[#0052CC] bg-blue-50/60" : "border-slate-200"}`}>
          <div className="flex items-center gap-2 text-xs font-semibold text-slate-800">
            <span className={`w-5 h-5 rounded-full grid place-items-center text-[10px] ${s.done ? "bg-emerald-600 text-white" : i === current ? "bg-[#0052CC] text-white" : "bg-slate-200 text-slate-600"}`}>
              {s.done ? <Check className="w-3 h-3" /> : i + 1}
            </span>
            {s.t}
          </div>
          <div className="text-[11px] text-slate-500 mt-1 pl-7">{s.d}</div>
        </li>
      ))}
    </ol>
  );
};
